<template>
    <v-row>
        <v-col cols="4">
            <v-list>
                <v-list-item v-for="(action, idx) in actions" :key="idx" @click="dispatch(action)">
                    <v-list-item-icon>
                        <v-fa-icon icon="space-shuttle" />
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title v-text="action.id"></v-list-item-title>
                        <v-list-item-subtitle>
                            <pre>{{ action.param }}</pre>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-col>
        <v-col>
            <v-select v-model="selectedModule" :items="availableModules" label="Vuex Module" />
            <pre>{{ state }}</pre>
        </v-col>
    </v-row>
</template>

<script>
import { FETCH_DEVICE_TREE, FETCH_ALL_DEVICE_TREE } from "@/store/modules/DevicesModule/actions";

export default {
    data: () => ({
        actions: [
            { id: FETCH_DEVICE_TREE, param: null },
            { id: FETCH_ALL_DEVICE_TREE, param: null },
            { id: FETCH_DEVICE_TREE, param: 0 },
            { id: FETCH_DEVICE_TREE, param: 18 },
        ],
        selectedModule: "devices",
    }),
    computed: {
        availableModules() {
            return Object.keys(this.$store.state);
        },
        state() {
            return this.$store.state[this.selectedModule];
        },
    },
    methods: {
        dispatch(action) {
            console.log("dispatch action: ", action);
            this.$store.dispatch(action.id, action.param);
        },
    },
};
</script>
